import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Card,
  CardContent,
  Checkbox,
  Typography,
  Chip,
  Grid,
  List,
  ListItem,
  Divider,
  Collapse
} from '@material-ui/core';

// import config from '../../config/config.json'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  card: {
    width: '100%'
  }
}));

const UsersList = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    setUsers(props.users);
  }, [props.users]);

  const handleChange = (data) => event => {
    props.onChange(data);
  };

  const filterUsers = couponStateFilterId => {
    return couponStateFilter(props.users, couponStateFilterId);
    // return customerTypeFilter(couponStateFilter(props.users, couponStateFilterId), customerTypeFilterId)
  };

  const couponStateFilter = (usersNew, couponStateFilterId) => {
    switch (parseInt(couponStateFilterId)) {
      case 1:
        return usersNew.reduce((res, user) =>{
          const newUser = {...user, meals:[...user.meals.filter(m => !m.checked)]} 
          
          if (newUser.meals.length > 0){
            res.push(newUser)
          }
          return res
        },[])
      case 2:
        return usersNew.reduce((res, user) =>{
          // user.meals = [...user.meals.filter(m => m.checked)] 
          const newUser = {...user, meals:[...user.meals.filter(m => m.checked)]} 

          if (newUser.meals.length > 0){
            res.push(newUser)
          }
          return res
        },[])
      case 3:
        return usersNew;
    }
  };

  const getColapseStae = checked => {
    switch (props.couponStateFilter) {
      case 1:
        return checked ? true : false;
      case 2:
        return checked ? false : true;
      case 3:
        return true;
    }
  };

  //   Изменение фильтров
  useEffect(() => {
    setUsers(filterUsers(props.couponStateFilter));
  }, [props.couponStateFilter]);

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        {users && users.length > 0 && (
          <PerfectScrollbar>
            <div className={classes.inner}>
              <List dense={true}>
                {/* {JSON.stringify(users)} */}
                {_.sortBy(users, 'user_name', 'asc').map(user => (
                  <React.Fragment key={user.user_id}>
                    {user.meals.map(meal => (
                      <React.Fragment key={`${user.user_id}_${meal.mealId}`}>
                        <Collapse
                          in={getColapseStae(!meal.checked)}
                          timeout={{ exit: 400, enter: 400 }}>
                          <ListItem>
                            <Grid
                              container
                              direction="row"
                              justify="flex-start"
                              alignItems="center"
                              spacing={1}>
                              <Grid item xs={8}>
                                <Typography
                                  variant="h5"
                                  component="h2"
                                  style={
                                    meal.checked
                                      ? {
                                          textDecoration: 'line-through',
                                          fontWeight: 600
                                        }
                                      : { fontWeight: 600 }
                                  }>
                                  {user.customertype_id === 'team' && '😻 '}
                                  {user.customertype_id === 'special' && '🔥 '}
                                  {user.user_name}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  component="h3"
                                  style={
                                    meal.checked
                                      ? {
                                          textDecoration: 'line-through',
                                          fontWeight: 300
                                        }
                                      : { fontWeight: 300 }
                                  }>
                                  {`${meal.mealName} - ${meal.amount}`}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Grid
                                  container
                                  direction="row"
                                  justify="flex-end"
                                  alignItems="center">
                                  <Checkbox
                                    edge="end"
                                    onChange={handleChange({
                                      userId: user.user_id,
                                      mealId: meal.mealId,
                                      checked: meal.checked
                                    })}
                                    checked={meal.checked}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </ListItem>
                          <Divider component="li" />
                        </Collapse>
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </List>
            </div>
          </PerfectScrollbar>
        )}
      </CardContent>
    </Card>
  );
};

export default UsersList;
